<template>
  <component :is="componentToShow"
             :to="cta ? cta.href : ''"
             :target="cta && cta.href && cta.href.toLowerCase().startsWith('http') ? '_blank' : ''"
             class="relative flex flex-col justify-end w-full overflow-hidden text-white bg-cover shadow-2xl rounded-xl group"
             @click="handleClick"
  >
    <!-- Wrapper for @tailwindcss/aspect-ratio padding trick -->
    <div class="flex flex-col justify-end p-6 w-full">
      <!-- Clip path for Safari mouse over effect, to clip rounded corners -->
      <div v-if="backgroundImage"
           class="absolute inset-0 w-full h-full overflow-hidden rounded-xl"
           :style="{ clipPath: 'content-box' }"
      >
        <NuxtImg :src="backgroundImage"
                 :alt="title || ''"
                 class="object-cover w-full h-full transition duration-300 transform rounded-xl"
                 :class="cta && cta.href ? 'group-hover:scale-110' : ''"
                 sizes="xs:184vw sm:120vw md:728px lg:728px xl:728px xxl:728px"
                 loading="lazy"
                 fit="inside"
        />
      </div>
      <div v-if="title || copy || cta"
           class="absolute inset-0 w-full h-full transform rounded-xl"
           :style="{
             background: 'linear-gradient(360deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 60%)',
           }"
      />
      <div class="max-w-md">
        <h3 class="relative text-2xl"
            v-html="title"
        />
        <div v-if="copy && copy.length > 0"
             class="relative font-normal mt-2.5"
             v-html="copy"
        />
      </div>
      <ButtonBase v-if="cta"
                  :type="cta.type"
                  :label="cta.title"
                  :href-type="hrefType"
                  class="relative flex items-center mt-6 pointer-events-none"
      />
    </div>
  </component>
</template>

<script setup lang="ts">
import { computed, resolveComponent } from 'vue'
import { useLinkType } from '../../composables/link-type'
import type { CtaType } from '../../models/button'

type CardImageProps = {
  title?: string
  copy?: string
  cta?: CtaType
  backgroundImage: string
}

const props = defineProps<CardImageProps>()
const { $event: trackEvent } = useNuxtApp()

const componentToShow = computed(() => {
  if (props.cta && props.cta.href && props.cta.href.length > 0) {
    return resolveComponent('NuxtLink')
  }
  return 'div'
})

const hrefType = computed(() => {
  if (props.cta && props.cta.href && props.cta.href.length > 0) {
    return useLinkType(props.cta.href)
  }

  return null
})

function handleClick() {
  trackEvent('Card Click', {
    props: {
      ['Type']: 'image',
      ['Title']: props.title,
      ['URL']: props.cta?.href,
      ['Background Image']: props.backgroundImage
    }
  })
}
</script>
